import React from "react";
import {Address as AddressType} from "../../interfaces/customer-interface";
import {config} from "../../config-merchant";

export default function Address(props: { address: AddressType }) {
    return (
        <div>
            <p>{props.address.name}</p>
            {config.enabledB2B && <p>{props.address.companyName}</p>}
            <p>{props.address.streetNumber} {props.address.route}</p>
            <p>{props.address.postalCode} {props.address.locality}</p>
            <p>{props.address.country}</p>
        </div>
    )
}
